/**
 * RTWO Blockchain Core Foundation — Public API
 * RTWO v2.2 | Module ID: RTWO-BLCK-001
 */

export {
  BLOCKCHAIN_CORE_VERSION,
  type BlockchainCoreBlock,
  type BlockchainCoreDataStatus,
  type BlockchainCoreLookupType,
  type LatestBlockResult,
  type BlockLookupResult,
  type BlockchainCoreValidationResult,
  type BlockchainCoreCheck,
} from './domain-models';

export {
  isBlockchainCoreEnabled,
  isBlockchainCoreBackendEnabled,
  BLOCKCHAIN_CORE_API_ROUTES,
} from './configuration/blockchain-core-config';

export type { IBlockchainCoreBlockRepository } from './repositories/block-repository-interface';

export { InMemoryBlockRepository } from './repositories/in-memory-block-repository';
export { ProtocolBlockRepositoryAdapter } from './repositories/protocol-block-repository-adapter';

export { BlockRuntimeService } from './services/block-runtime-service';
export {
  getBlockRuntimeService,
  resetBlockRuntimeServiceForTests,
} from './factory/create-blockchain-core-runtime';

export { validateBlockchainCore } from './validation/validate-blockchain-core';
